/* Lightweight Shopify cart callbacks used by legacy product-grid buttons. */
(function() {
  if (!window.Shopify) return;

  function updateBadges(cart) {
    var count = cart && cart.item_count ? cart.item_count : 0;

    document.querySelectorAll('[data-kiro-cart-badge]').forEach(function(badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });

    document.querySelectorAll('.bigcounter').forEach(function(counter) {
      if (counter.hasAttribute('data-kiro-cart-badge')) return;
      counter.textContent = count;
    });
  }

  function syncCart(cart) {
    if (window.kiroSyncCartUI) {
      return window.kiroSyncCartUI(cart).catch(function() {
        updateBadges(cart);
      });
    }

    updateBadges(cart);
    return Promise.resolve(cart);
  }

  Shopify.onItemAdded = function() {
    if (typeof Shopify.getCart === 'function') {
      Shopify.getCart();
    }
  };

  Shopify.onCartUpdate = function(cart) {
    syncCart(cart);
  };

  Shopify.cartUpdateInfo = function(cart) {
    syncCart(cart);
  };
})();
